import * as React from "react";

interface Props {
  organizationName: string;
  onSsoLogin: () => void;
  onPasswordLogin: () => void;
}

export const SsoChoiceStep: React.FC<Props> = ({ organizationName, onSsoLogin, onPasswordLogin }) => (
  <>
    <div className="mb-4 text-center">
      <p className="text-sm text-ui-paragraph-text">
        <span className="font-medium">{organizationName}</span> uses Single Sign-On.
      </p>
    </div>

    <div className="space-y-3">
      <button
        type="button"
        onClick={onSsoLogin}
        className="flex w-full justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-sm hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
      >
        Sign in with SSO
      </button>

      <button
        type="button"
        onClick={onPasswordLogin}
        className="flex w-full justify-center rounded-md border border-input bg-transparent px-4 py-2 text-sm font-medium text-ui-paragraph-text shadow-sm hover:bg-muted/50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
      >
        Use password instead
      </button>
    </div>
  </>
);
